import { PreferredGenresSettings } from '@/components/settings/PreferredGenresSettings'
import { SettingsLayout, type SettingsSection } from '@/components/settings/SettingsLayout'

// Define as seções de configuração
const settingsSections: SettingsSection[] = [
  {
    id: 'preferred-genres',
    titleKey: 'settings.preferredGenres.title',
    descriptionKey: 'settings.sections.preferredGenres.description',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
        />
      </svg>
    ),
    component: () => (
      <div className="p-6">
        <PreferredGenresSettings />
      </div>
    ),
  },
  // Placeholder para futuras seções - facilmente extensível
  {
    id: 'account',
    titleKey: 'settings.sections.account.title',
    descriptionKey: 'settings.sections.account.description',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
        />
      </svg>
    ),
    component: () => (
      <div className="p-8 text-center">
        <div className="text-muted-foreground">
          <p className="text-lg font-medium mb-2">Configurações de Conta</p>
          <p className="text-sm">Esta seção estará disponível em breve.</p>
        </div>
      </div>
    ),
    badge: 'Em breve',
  },
  {
    id: 'notifications',
    titleKey: 'settings.sections.notifications.title',
    descriptionKey: 'settings.sections.notifications.description',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
        />
      </svg>
    ),
    component: () => (
      <div className="p-8 text-center">
        <div className="text-muted-foreground">
          <p className="text-lg font-medium mb-2">Notificações</p>
          <p className="text-sm">Configure suas preferências de notificação.</p>
          <p className="text-xs mt-2 opacity-70">Funcionalidade em desenvolvimento.</p>
        </div>
      </div>
    ),
    badge: 'Em breve',
  },
  {
    id: 'appearance',
    titleKey: 'settings.sections.appearance.title',
    descriptionKey: 'settings.sections.appearance.description',
    icon: (
      <svg
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M4.098 19.902A3.75 3.75 0 109.402 15.6M4.098 19.902l6.401-6.401M9.402 15.6l6.401-6.402a3.75 3.75 0 000-5.304 3.75 3.75 0 00-5.304 0L4.098 10.195M9.402 15.6a3.75 3.75 0 000 5.302z"
        />
      </svg>
    ),
    component: () => (
      <div className="p-8 text-center">
        <div className="text-muted-foreground">
          <p className="text-lg font-medium mb-2">Aparência</p>
          <p className="text-sm">Configure temas, cores e layout da aplicação.</p>
          <p className="text-xs mt-2 opacity-70">Funcionalidade em desenvolvimento.</p>
        </div>
      </div>
    ),
    badge: 'Em breve',
  },
]

export function SettingsPage() {
  return <SettingsLayout sections={settingsSections} defaultSection="preferred-genres" />
}
